var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompleteBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 393,
    height: 852,
    viewBox: "0 0 393 852",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12001_4364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0H369C382.255 0 393 10.7452 393 24V828C393 841.255 382.255 852 369 852H24C10.7452 852 0 841.255 0 828V24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06,
    clipPath: "url(#clip1_12001_4364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.905 154.575L267.696 147.703L249.059 141.377L246.269 148.249L264.905 154.575Z",
    fill: "#294E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.51 254.552L269.119 247.108L261.686 250.625L267.077 258.069L274.51 254.552Z",
    fill: "#294E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.879 244.833L246.867 238.875L239.672 238.124L239.684 244.082L246.879 244.833Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.733 587.296L215.45 586.669L208.074 569.987L202.357 570.613L209.733 587.296Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.127 170.422L208.978 165.287L202.43 163.248L201.579 168.383L208.127 170.422Z",
    fill: "#294E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.439 163.916H134.306L128.917 147.478H123.05L128.439 163.916Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.252 257.792L233.392 255.388L234.222 263.408L240.082 265.812L239.252 257.792Z",
    fill: "#294E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.673 237.212L199.81 230.08L184.572 233.014L188.435 240.146L203.673 237.212Z",
    fill: "#0E121B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.91 677.158L375.841 674.581L369.299 682.121L372.369 684.698L378.91 677.158Z",
    fill: "#294E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.722 182.266L280.87 176.104L264.196 166.539L261.047 172.701L277.722 182.266Z",
    fill: "#294E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.538 599.725L263.558 593.076L251.551 597.696L255.531 604.345L267.538 599.725Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.83 693.635L316.156 690.379L311.886 700.498L318.559 703.754L322.83 693.635Z",
    fill: "#294E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4877 390.959L76.5173 384.397L53.6198 372.482L52.5902 379.043L75.4877 390.959Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.867 179.839L364.151 180.132L359.821 168.163L355.538 167.87L359.867 179.839Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.263 243.211L186.309 237.18L177.968 237.475L176.921 243.506L185.263 243.211Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5599 752.198L29.3091 745.723L26.4331 750.782L34.684 757.257L37.5599 752.198Z",
    fill: "#294E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.881 197.2L201.186 190.368L187.199 183.996L186.894 190.828L200.881 197.2Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.036 699.163L330.804 699.919L332.663 709.481L337.895 708.725L336.036 699.163Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.832 685.313L268.553 682.333L263.809 678.927L262.088 681.907L266.832 685.313Z",
    fill: "#294E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.774 361.362L267.94 355.35L254.825 365.045L259.659 371.057L272.774 361.362Z",
    fill: "#294E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.083 829.026L330.467 825.41L325.53 829.1L328.146 832.716L333.083 829.026Z",
    fill: "#294E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.935 382.546L280.034 381.404L280.172 373.179L274.073 374.321L273.935 382.546Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.294 300.563L341.548 293.235L324.433 287.079L322.18 294.408L339.294 300.563Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.702 407.018L358.815 400.504L339.468 403.167L339.355 409.681L358.702 407.018Z",
    fill: "#294E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.461 375.498L125.061 369.371L116.524 366.298L116.924 372.424L125.461 375.498Z",
    fill: "#0E121B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.741 744.87L138.205 741.614L129.225 735.965L127.761 739.221L136.741 744.87Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6739 760.371L77.1489 756.233L64.7865 769.24L69.3115 773.378L81.6739 760.371Z",
    fill: "#294E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.409 237.002L292.963 232.606L289.583 238.143L295.028 242.538L298.409 237.002Z",
    fill: "#294E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.185 297.93H231.912L227.43 282.907H219.703L224.185 297.93Z",
    fill: "#0E121B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.834 807.369L260.772 803.014L252.016 795.936L249.077 800.291L257.834 807.369Z",
    fill: "#294E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.468 740.782L150.05 736.03L143.533 735.228L142.952 739.98L149.468 740.782Z",
    fill: "#0E121B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.458 -15.2499L207.679 -16.2061L208.192 1.7643L215.97 2.72047L215.458 -15.2499Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.015 398.102L323.868 393.329L319.542 397.645L324.69 402.418L329.015 398.102Z",
    fill: "#294E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.022 174.169L183.949 171.462L178.833 179.99L182.905 182.697L188.022 174.169Z",
    fill: "#0E121B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.406 381.403L248.215 378.054L239.332 370.843L236.523 374.192L245.406 381.403Z",
    fill: "#294E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8482 532.838L52.718 527.729L40.9777 539.012L46.1079 544.121L57.8482 532.838Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0214 63.7404L31.2712 58.3838L22.9924 59.2596L23.7425 64.6162L32.0214 63.7404Z",
    fill: "#0E121B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.182 249.613L162.339 244.706L152.695 242.798L153.538 247.705L163.182 249.613Z",
    fill: "#0E121B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1253 433.357L25.8176 428.073L12.9567 439.16L17.2644 444.445L30.1253 433.357Z",
    fill: "#0E121B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.475 60.9592L253.523 59.9609L250.211 42.7955L243.162 43.7938L246.475 60.9592Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4963 461.547L48.5754 459.95L50.075 473.921L56.9959 475.517L55.4963 461.547Z",
    fill: "#0E121B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.345 319.477L219.765 315.367L208.598 318.148L209.178 322.258L220.345 319.477Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.091 330.352L335.443 322.783L322.779 327.055L326.426 334.624L339.091 330.352Z",
    fill: "#294E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3439 682.084L45.6592 676.764L39.0078 675.385L36.6926 680.705L43.3439 682.084Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.913 572.095L207.243 567.483L201.327 575.901L206.996 580.512L212.913 572.095Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.435 374.797L184.766 369.68L169.137 375.06L169.806 380.178L185.435 374.797Z",
    fill: "#294E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.283 299.577L51.0039 298.849L45.1514 284.61L39.4305 285.339L45.283 299.577Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.187 96.2981L388.697 92.2383L382.514 90.6476L381.004 94.7074L387.187 96.2981Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.035 628.856L344.992 627.447L344.972 622.265L340.015 623.673L340.035 628.856Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6399 707.267L91.7498 700.521L76.8265 691.086L73.7167 697.832L88.6399 707.267Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.744 757.174L163.044 750.307L149.162 754.681L151.862 761.549L165.744 757.174Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.873 307.613L98.813 301.815L91.2551 309.249L96.315 315.047L103.873 307.613Z",
    fill: "#294E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.294 281.004L189.875 275.648L178.941 274.059L177.359 279.415L188.294 281.004Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.648 314.743L118.657 313.909L118.154 328.148L124.145 328.981L124.648 314.743Z",
    fill: "#0E121B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5346 382.228L94.4988 374.473L83.4332 375.265L86.4691 383.02L97.5346 382.228Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.071 591.53L171.677 587.187L161.312 592.25L163.706 596.594L174.071 591.53Z",
    fill: "#294E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.945 300.476L288.314 296.197L285.341 303.327L291.972 307.606L294.945 300.476Z",
    fill: "#294E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.975 527.601L138.921 519.87L121.069 521.808L124.123 529.539L141.975 527.601Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.839 344.317L335.029 339.292L329.019 336.935L326.829 341.959L332.839 344.317Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.78 91.328L277.09 87.4585L270.073 77.7752L264.762 81.6447L271.78 91.328Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.477 195.213L201.815 196.274L198.622 187.851L192.284 186.79L195.477 195.213Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.443 787.723L376.329 780.703L358.529 774.862L358.643 781.882L376.443 787.723Z",
    fill: "#294E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.057 258.614L398.643 255.397L390.836 246.466L387.25 249.683L395.057 258.614Z",
    fill: "#294E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.825 251.646L351.417 247.661L342.442 244.721L341.851 248.706L350.825 251.646Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.022 448.607L124.991 448.035L120.313 440.163L115.344 440.736L120.022 448.607Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.714 535.32L166.83 533.224L163.171 513.22L156.055 515.317L159.714 535.32Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.338 461.865L355.673 460.609L351.546 445.923L345.211 447.179L349.338 461.865Z",
    fill: "#0E121B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.428 740.104L375.321 736.956L367.69 749.865L373.798 753.014L381.428 740.104Z",
    fill: "#0E121B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.942 623.226H342.762L337.451 601.232H330.631L335.942 623.226Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5837 661.794L95.3826 660.55L91.1897 643.587L85.3909 644.831L89.5837 661.794Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.736 191.41L346.629 186.793L336.102 182.855L333.208 187.472L343.736 191.41Z",
    fill: "#0E121B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.058 148.375L179.901 145.354L174.02 151.606L177.177 154.626L183.058 148.375Z",
    fill: "#0E121B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1195 153.579L98.8279 152.744L95.3197 144.769L91.6113 145.604L95.1195 153.579Z",
    fill: "#294E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.39 17.9686L234.946 17.5029L233.399 33.2427L239.843 33.7084L241.39 17.9686Z",
    fill: "#294E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.206 341.501L224.901 336.068L212.106 336.997L213.411 342.43L226.206 341.501Z",
    fill: "#0E121B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1794 343.546L40.821 342.184L37.2512 335.967L33.6095 337.329L37.1794 343.546Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.386 29.5041L250.535 24.8452L239.886 31.1214L242.738 35.7803L253.386 29.5041Z",
    fill: "#0E121B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.263 432.042L183.384 425.774L172.691 422.072L169.57 428.339L180.263 432.042Z",
    fill: "#294E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.378 136.596L47.2693 130.91L41.3581 124.793L35.4669 130.478L41.378 136.596Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.513 611.048L135.312 609.019L131.267 600.65L127.468 602.68L131.513 611.048Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.925 28.7217L271.074 26.9609L268.282 17.3017L263.133 19.0625L265.925 28.7217Z",
    fill: "#294E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.893 631.764L307.511 631.653L302.87 616.486L297.252 616.596L301.893 631.764Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.98 616.915L285.879 613.187L281.087 610.744L279.188 614.472L283.98 616.915Z",
    fill: "#294E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.921 617.585L18.1304 613.198L9.72534 601.19L3.51597 605.578L11.921 617.585Z",
    fill: "#0E121B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.831 211.676L355.829 210.083L353.616 216.449L358.618 218.041L360.831 211.676Z",
    fill: "#0E121B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.875 475.961L145.887 474.394L144.036 479.935L148.024 481.502L149.875 475.961Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.966 18.9584L136.352 11.9614L121.279 15.8866L123.893 22.8835L138.966 18.9584Z",
    fill: "#0E121B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.209 672.4L301.883 669.017L295.331 661.829L291.657 665.211L298.209 672.4Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4918 288.325L17.5857 284.591L10.2773 289.827L13.1834 293.561L20.4918 288.325Z",
    fill: "#0E121B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.391 815.805L285.202 814.18L284.194 828.26L291.383 829.886L292.391 815.805Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.638 758.879L112.651 752.489L92.7533 743.264L90.7395 749.654L110.638 758.879Z",
    fill: "#0E121B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2761 773.891L34.9485 769.985L23.1325 753.943L17.4601 757.85L29.2761 773.891Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7942 115.939L61.6079 111.304L51.5451 120.638L55.7314 125.274L65.7942 115.939Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.976 378.398L356.475 373.654L343.594 371.459L344.095 376.202L356.976 378.398Z",
    fill: "#294E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.759 694.291L395.1 692.712L392.203 698.295L395.862 699.874L398.759 694.291Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.546 752.933L382.197 745.574L373.49 745.735L374.84 753.094L383.546 752.933Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.809 174.477L299.967 169.979L290.448 173.432L291.29 177.929L300.809 174.477Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.506 598.056L279.837 596.247L274.317 583.377L269.986 585.186L275.506 598.056Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.76489 63.2602L8.36304 56.8491L-9.34615 47.7589L-11.9443 54.17L5.76489 63.2602Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.165 731.138L330.918 725.586L322.759 724.027L325.007 729.579L333.165 731.138Z",
    fill: "#294E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1192 51.741L52.1851 47.5703L40.2156 46.3179L40.1497 50.4886L52.1192 51.741Z",
    fill: "#0E121B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.74 11.528L253.311 12.2881L252.305 21.9033L257.734 21.1431L258.74 11.528Z",
    fill: "#294E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6953 562.632L71.9753 560.902L71.6948 566.248L76.4148 567.977L76.6953 562.632Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.712 781.052L225.972 773.809L206.198 775.244L207.938 782.487L227.712 781.052Z",
    fill: "#0E121B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.914 237.616L47.5081 234.607L43.3945 240.554L47.8005 243.562L51.914 237.616Z",
    fill: "#294E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.478 450.739L204.369 446.325L189.988 440.665L190.097 445.079L204.478 450.739Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.249 312.69L215.125 308.791L203.95 304.299L203.074 308.198L214.249 312.69Z",
    fill: "#0E121B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.727 584.602L339.731 579.817L330.392 572.246L326.387 577.031L335.727 584.602Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.626 254.507L289.18 248.677L274.527 260.791L278.974 266.622L293.626 254.507Z",
    fill: "#0E121B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3926 722.227L90.2749 719.531L85.0885 732.502L90.2062 735.198L95.3926 722.227Z",
    fill: "#0E121B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.533 158.735L386.395 156.514L383.76 165.384L388.898 167.605L391.533 158.735Z",
    fill: "#294E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.828 94.0601L369.876 89.2412L359.877 94.6976L362.829 99.5165L372.828 94.0601Z",
    fill: "#294E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.249 438.808L385.623 435.134L373.745 421.759L369.371 425.434L381.249 438.808Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.249 675.863L217.946 673.765L212.979 667.31L209.282 669.409L214.249 675.863Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.087 371.678L394.2 365.854L385.189 372.201L389.076 378.025L398.087 371.678Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0175 317.336L51.2629 314.812L44.5062 306.2L41.2607 308.723L48.0175 317.336Z",
    fill: "#294E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.166 586.325L361.266 585.279L359.933 596.546L365.832 597.591L367.166 586.325Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.552 376.489L396.279 377.071L391.066 363.771L384.34 363.189L389.552 376.489Z",
    fill: "#294E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5859 156.952L30.0762 155.629L28.3299 160.819L32.8396 162.142L34.5859 156.952Z",
    fill: "#0E121B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.784 534.02L355.457 528.312L346.614 522.401L344.941 528.109L353.784 534.02Z",
    fill: "#0E121B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5645 814.524L41.6938 813.358L38.2585 808.1L34.1291 809.266L37.5645 814.524Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7457 558.506L50.2251 555.822L45.9445 567.187L50.4651 569.87L54.7457 558.506Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2607 624.383L37.4333 622.158L31.4608 614.526L28.2881 616.752L34.2607 624.383Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.21902 553.377L2.72656 548.847L-1.28382 543.252L-7.22941 547.782L-3.21902 553.377Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.355 72.6709L283.522 64.9961L262.608 61.8169L263.44 69.4917L284.355 72.6709Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.169 106.691L297.688 103.439L288.79 97.797L287.271 101.049L296.169 106.691Z",
    fill: "#294E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.435 265.783L378.479 263.965L369.656 247.317L364.612 249.135L373.435 265.783Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.369 324.115L322.848 317.458L314.3 319.644L318.822 326.302L327.369 324.115Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.566 401.193L171.078 397.192L159.711 384.385L154.198 388.386L165.566 401.193Z",
    fill: "#0E121B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3153 506.175L77.5107 500.96L63.5353 495.576L63.3398 500.79L77.3153 506.175Z",
    fill: "#0E121B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.169 135.687L99.7917 128.525L81.1885 127.556L81.5658 134.718L100.169 135.687Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.641 378.906L117.699 374.462L106.075 365.659L103.017 370.103L114.641 378.906Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.086 734.551L221.778 731.383L216.627 726.829L213.936 729.996L219.086 734.551Z",
    fill: "#294E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6929 310.699L60.7715 307.218L55.1785 313.184L59.0999 316.664L64.6929 310.699Z",
    fill: "#0E121B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.286 813.719L386.197 811.319L382.492 815.725L385.582 818.125L389.286 813.719Z",
    fill: "#0E121B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.904 475.571L249.3 471.652L237.354 463.763L234.958 467.682L246.904 475.571Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.496 646.976L330.349 640.77L316.683 643.325L319.83 649.532L333.496 646.976Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.504 277.717L297.713 277.525L294.005 264.702L288.796 264.894L292.504 277.717Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.778 766.549L26.0786 764.503L15.645 752.026L11.3444 754.071L21.778 766.549Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.421 721.519L103.469 715.058L97.0604 720.343L103.013 726.804L109.421 721.519Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.535 416.917L197.847 414.403L197.264 418.358L201.952 420.872L202.535 416.917Z",
    fill: "#0E121B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7742 327.108L52.7708 321.541L45.7891 315.953L40.7925 321.52L47.7742 327.108Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.252 70.8275L305.618 68.0791L301.556 73.9507L305.19 76.6991L309.252 70.8275Z",
    fill: "#294E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.38 605.289L100.568 599.239L88.9038 604.881L91.7162 610.931L103.38 605.289Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.224 199.023L343.065 194.865L334.974 196.034L336.133 200.192L344.224 199.023Z",
    fill: "#0E121B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.143 142.333L216.771 139.216L210.615 148.808L215.988 151.925L222.143 142.333Z",
    fill: "#4A8DFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12001_4364"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0H369C382.255 0 393 10.7452 393 24V828C393 841.255 382.255 852 369 852H24C10.7452 852 0 841.255 0 828V24Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_12001_4364"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 393,
    height: 852,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteBg);
export default __webpack_public_path__ + "static/media/complete_bg.3722167c5b714dd4ff3939ac85d84f25.svg";
export { ForwardRef as ReactComponent };